<template>
  <div>
    <el-dialog
        :title="$t('posts.dialog.selectProgram')"
        :visible.sync="modalShowProgramsPromoter"
        width="30%"
    >
      <el-form :rules="rulesPromoter">
        <el-form-item :label="$t('posts.dialog.choiceOfProgram') + ' *'" prop="annonceParente">
          <el-select v-model="annonceParente"
                     :placeholder="$t('posts.dialog.choiceOfProgram')"
                     clearable>
            <el-option
                v-for="program in this.programsModalPromoter"
                :key="program.id"
                :label="program.reference + ' - ' + program.titre"
                :value="program.id"
            ></el-option>

          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="cancelCreateLot()">{{ $t("posts.dialog.cancel") }}</el-button>
                <el-button type="primary" @click="createLot()">{{ $t("posts.dialog.confirm") }}</el-button>
            </span>
    </el-dialog>
  </div>

</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import ElButton from '../../../../components/Button'

export default {
  name: 'DialogShowProgramsPromoter',
  components: {
    ElButton
  },
  props: ['filter'],
  data () {
    return {
      rulesPromoter: {
        selectTypeObjetModele: [{ required: true, message: this.$t('validator.selectTypeObjetModeleRequired'), trigger: 'blur' }],
        annonceParente: [{ required: true, message: this.$t('validator.annonceParenteRequired'), trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['hasMultiAccounts', 'isMainAccount', 'isSubAdmin', 'isSubUser', 'getOfferTypes', 'getPickerOptionsShortcuts']),
    ...mapState('postsListImmo', ['programsModalPromoter', 'annonceParente']),
    ...mapState('dialogsPostsListImmo', ['modalShowProgramsPromoter']),
    userFilter () {
      return this.filter.user
    },
    annonceParente: {
      get () {
        return this.$store.getters['postsListImmo/annonceParente']
      },
      set (value) {
        this.$store.commit('postsListImmo/SET_ANNONCE_PARENTE', value)
      }
    },
    modalShowProgramsPromoter: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/modalShowProgramsPromoter']
      },
      set (value) {
        this.$store.commit('dialogsPostsListImmo/SET_MODAL_SHOW_PROGRAMS_PROMOTER', value)
      }
    }
  },
  methods: {
    ...mapMutations('dialogsPostsListImmo', ['SET_MODAL_SHOW_PROGRAMS_PROMOTER']),
    ...mapMutations('postsListImmo', ['SET_ANNONCE_PARENTE']),
    createLot () {
      this.$router.push({
        name: 'post-new'
      })
    },
    cancelCreateLot () {
      this.SET_ANNONCE_PARENTE(null)
      this.SET_MODAL_SHOW_PROGRAMS_PROMOTER(false)
    }
  },
  beforeMount () {

  }
}

</script>
